import "./ConfirmModal.css";

const actionConfig = {
  delete: {
    confirmLabel: "Archive",
    confirmClass: "btn-danger",
  },
  block: {
    confirmLabel: "Block",
    confirmClass: "btn-warning",
  },
  unblock: {
    confirmLabel: "Unblock",
    confirmClass: "btn-primary",
  },
  recover: {
    confirmLabel: "Recover",
    confirmClass: "btn-primary",
  },
  permanent: {
    confirmLabel: "Delete Permanently",
    confirmClass: "btn-danger",
  },
  save: {
    confirmLabel: "Save Changes",
    confirmClass: "btn-primary",
  },
  approve: {
    confirmLabel: "Approve",
    confirmClass: "btn-primary",
  },
  reject: {
    confirmLabel: "Reject",
    confirmClass: "btn-danger",
  },
};

const ConfirmModal = ({ open, title, message, onConfirm, onCancel, type = "delete" }) => {
  if (!open) return null;

  const config = actionConfig[type] || actionConfig.delete;

  return (
    <div className="confirm-overlay">
      <div className="confirm-box">
        {title && <h3>{title}</h3>}
        <p>{message}</p>
        <div className="confirm-actions">
          <button className="btn-cancel" onClick={onCancel}>Cancel</button>
          <button className={config.confirmClass} onClick={onConfirm}>
            {config.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;